import { __decorate, __metadata } from "tslib";
import { DiningOptionEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional } from 'class-validator';
import { DefaultStoreExposeGroup } from '../interface';
export class ReadDefaultStoreFeaturesFlagsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true, description: 'Enable/Disable availableAt' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.UPDATE] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isAvailableAtEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isNotesEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isDelayedOrderEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true, description: 'Enable/Disable Cash payments' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.UPDATE] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isPayByCashEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "giftcardsPaymentsEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "giftcardsPurchaseEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isGooglePayEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isGooglePayMobileAndroidEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isGooglePayMobileIOSEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isApplePayEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isApplePayMobileEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isDynamicMenuEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isDelayedOrderValidationEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isOrderThrottlingEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isMinMaxRelativeToGrossTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isItemBaseGroupEnabled", void 0);
__decorate([
    ApiPropertyOptional({ enum: DiningOptionEnum, isArray: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsEnum(DiningOptionEnum, { groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH], each: true }),
    __metadata("design:type", Array)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "availableDiningOptions", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isNotifierRabbitMQEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "disableSendEmailLoginCode", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "showDealsPage", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Boolean,
        default: false,
        description: 'Use Strong Customer Authentication. Verify the buyer and reduce the chance of fraudulent transactions. Link - https://developer.squareup.com/docs/sca-overview-paymentform',
    }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isStrongCustomerAuthenticationEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Disable asap ordering after business hours, including prep time' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isAsapOrderingAfterBusinessHoursDisabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Disable delayed ordering before business hours, including prep time' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isDelayedOrderingBeforeBusinessHoursDisabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Disable sending notification when order status is automatically changed' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "disableSendingNotificationOnAutoOrderStatusChange", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Use to enable the new checkout flow' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isNewCheckoutFlowEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false, description: 'Use to enable the new payment page' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isNewPaymentPageEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'Use to enable the guest checkout on the new checkout page' }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadDefaultStoreFeaturesFlagsDto.prototype, "isGuestCheckoutEnabled", void 0);
//# sourceMappingURL=ReadDefaultStoreFeaturesFlagsDto.js.map